var _path, _path2, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoUpdates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20.25C12.5 21.4926 11.4926 22.5 10.25 22.5C9.00736 22.5 8 21.4926 8 20.25C8 19.987 8.04512 19.7346 8.12803 19.5H12.372C12.4549 19.7346 12.5 19.987 12.5 20.25Z",
    fill: "#0B3A81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 4.93614V4C9.75 2.75736 10.7574 1.75 12 1.75C13.2426 1.75 14.25 2.75736 14.25 4V4.93614C16.4489 5.82622 18 7.98197 18 10.5V15C18 15.8284 18.6716 16.5 19.5 16.5H20V19.5H4V16.5H4.5C5.32843 16.5 6 15.8284 6 15V10.5C6 7.98197 7.55113 5.82622 9.75 4.93614ZM11.25 4C11.25 3.58579 11.5858 3.25 12 3.25C12.4142 3.25 12.75 3.58579 12.75 4V4.54642C12.5043 4.51578 12.254 4.5 12 4.5C11.746 4.5 11.4957 4.51578 11.25 4.54642V4ZM7.5 15V10.5C7.5 8.01472 9.51472 6 12 6C14.4853 6 16.5 8.01472 16.5 10.5V15C16.5 16.3062 17.3348 17.4175 18.5 17.8293V18H5.5V17.8293C6.66519 17.4175 7.5 16.3062 7.5 15Z",
    fill: "#0B3A81"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21.5303,
    y1: 2.03033,
    x2: 2.53033,
    y2: 21.0303,
    stroke: "#777D87",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUpdates);
export default __webpack_public_path__ + "static/media/no-updates.b746bc1e142130fc677f3eda347b6a7c.svg";
export { ForwardRef as ReactComponent };